import { createStyles, makeStyles, Theme } from "@material-ui/core/styles";
const drawerWidth = 240;

export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    optionsStyle: {
      flexGrow: 1,
      display: "flex",
      alignItems: "flex-end",
      paddingBottom: theme.mixins.toolbar.minHeight,
    },
    spacing: {
      paddingTop: theme.mixins.toolbar.minHeight,
    },
    drawer: {
      width: drawerWidth,
      flexShrink: 0,
      whiteSpace: "nowrap",
      zIndex: 90,
    },
    paper: {
      zIndex: 90,
      paddingTop: theme.mixins.toolbar.minHeight,
    },
    drawerOpen: {
      width: drawerWidth,
      transition: theme.transitions.create("width", {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.enteringScreen,
      }),
    },
    drawerClose: {
      transition: theme.transitions.create("width", {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen,
      }),
      overflowX: "hidden",
      width: theme.spacing(7) + 5,
      [theme.breakpoints.up("sm")]: {
        width: theme.spacing(9) + 10,
      },
    },
    toolbar: {
      display: "flex",
      alignItems: "center",
      justifyContent: "flex-end",
      padding: theme.spacing(0, 1),
      // necessary for content to be below app bar
      ...theme.mixins.toolbar,
    },
    icon: {
      width: "100%",
      height: "100%",
    },
    listItemIcon: {
      height: "100%",
      marginRight: "10px",
    },
    expandW: {
      width: "100%",
    },
    item: {
      display: "block",
      textAlign: "center",
    },
    itemOpen: {
      transition: theme.transitions.create("opacity", {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.enteringScreen,
      }),
      opacity: 1,
    },
    itemClose: {
      transition: theme.transitions.create("opacity", {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.enteringScreen,
      }),
      opacity: 0,
    },
    buttonContainer: {
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-between",
          height: `calc(80% - ${theme.mixins.toolbar.minHeight}px)`,
    },
  })
);
